import { DataTable } from "@msuite/ui/table";
import { useCostCenters } from "@/hooks/use-cost-centers";
import { CostCentersMenu } from "./cost-centers-menu";
import { columns } from "./cost-centers-table-config";

export function CostCenters() {
	/** Query */
	const { costCenters, isLoading, queryKey, refetch } = useCostCenters();

	/** Render */
	return (
		<DataTable
			data={costCenters}
			columns={columns}
			isLoading={isLoading}
			queryKey={queryKey}
			refetch={refetch}
			menu={<CostCentersMenu />}
			persistenceKey="organization-cost-centers-table"
			initialPinningState={{ start: ["number"] }}
		/>
	);
}
